import React from "react";
import T from "prop-types";
import { RadioGroupField } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";

const ConsignmentOrEmaRadioField = ({
  disabled = false,
  label = "Consignment or EMA",
  name = "consignment_type",
  required = true,
  options = [
    { value: "consignment", text: "Consignment" },
    { value: "ema", text: "EMA" }
  ]
}) => (
  <Field
    disabled={disabled}
    name={name}
    label={label}
    component={RadioGroupField}
    options={options}
    required={required}
  />
);

ConsignmentOrEmaRadioField.propTypes = {
  disabled: T.bool,
  label: T.string,
  name: T.string,
  required: T.bool,
  options: T.arrayOf(
    T.shape({
      value: T.string.isRequired,
      text: T.string.isRequired
    })
  )
};

export default ConsignmentOrEmaRadioField;



// WEBPACK FOOTER //
// ./app/modules/Consignments/Search/Create/ConsignmentOrEmaRadioField.jsx